import React from "react";

import Header from "./Header";
import LogoPortfolio from "./LogoPortfolio";
import Hero from "./Hero";
import Project from "./Project";
import Skill from "./Skill";
import About from "./About";
import Footer from "./Footer";

const App = () => {
  return (
    <div className="app-container">
      <LogoPortfolio />
      <Header />
      <Hero />
      <Project />
      <Skill />
      <About />
      <Footer />
    </div>
  );
};

export default App;
